import request from 'store/common/utils';


export const loginApi = ({ email, password }) => request({
  url: '/login',
  method: 'POST',
  data: { email, password },
});

export const logoutApi = () => request({
  url: '/logout',
  method: 'POST',
});

export const getUserApi = (signal) => request({
  url: '/me',
  method: 'GET',
  signal,
});

export const userUpdateApi = (data) => request({
  url: '/me',
  method: 'put',
  data,
});

export const forgotPasswordApi = (data) => request({
  url: '/forgot-password',
  method: 'POST',
  data,
});

export const resetPasswordApi = (data) => request({
  url: '/reset-password',
  method: 'POST',
  data,
});

export const validateEmailApi = (data) => request({
  url: '/check-email-availability',
  method: 'POST',
  data,
});

export const changePasswordApi = (data) => request({
  url: '/changePassword',
  method: 'post',
  data,
});
